import React from 'react';
import {observer} from 'mobx-react';
import {TechseeBaseComponent} from '@techsee/techsee-ui-common/lib/_shared/techsee-base-component';
import Translate from '../../translate/Translate';
import {TsModalImage} from '../../ts-modal-image/ts-modal-image';
import {EntryController} from '../entry/Entry.controller';
import './EntryWizard.style.scss';

interface EntryWizardProps {
    ctrl: EntryController;
}

@observer
export class EntryWizardComponent extends TechseeBaseComponent<EntryWizardProps> {
    renderInternal(): JSX.Element {
        const {ctrl} = this.props;

        return (
            <div className='dashboard-entry-container ts-entry-wizard' dir={ctrl.dir}>
                {/* Main content when no platform selected */}
                {!ctrl.isVisible('android') && !ctrl.isVisible('apple') && (
                    <main className='ts-wizard-content'>
                        <ol className='steps-list'>
                            <li>
                                <span className='orange-text'>
                                    <Translate text='WIZARD.ENTRY.WHAT_PHONE' />
                                </span>
                            </li>
                            <li>
                                <span className='orange-text'>
                                    <Translate text='WIZARD.ENTRY.TELL_SPEAKERPHONE' />
                                </span>
                                <div className='wizard-images-container'>
                                    <TsModalImage
                                        imageSrc='wizard/generic/iphone.png'
                                        imageTitle='iPhone'
                                        imageText='WIZARD.ENTRY.SPEAKER_PHONE'
                                        imageNote=''
                                    />
                                    <TsModalImage
                                        imageSrc='wizard/generic/android.png'
                                        imageTitle='Android'
                                        imageText='WIZARD.ENTRY.SPEAKER_PHONE'
                                        imageNote='WIZARD.SCREENS_MAY_VARY'
                                    />
                                </div>
                            </li>
                            <li>
                                <p className='margin-bottom-20'>
                                    <span className='orange-text'>
                                        <Translate text='WIZARD.ENTRY.SELECT_TYPE' />
                                    </span>
                                </p>
                                <div className='ts-inline-group'>
                                    <button
                                        type='submit'
                                        className='btn btn-wizard'
                                        onClick={() => ctrl.showInstructionsFor('apple')}>
                                        iPhone
                                    </button>
                                </div>
                                <div className='ts-inline-group'>
                                    <button
                                        type='submit'
                                        className='btn btn-wizard'
                                        onClick={() => ctrl.showInstructionsFor('android')}>
                                        Android
                                    </button>
                                </div>
                                <div className='ts-subtext text-left'>
                                    <Translate text='WIZARD.ENTRY.WINPHONE' />
                                </div>
                            </li>
                        </ol>
                    </main>
                )}

                {/* Platform-specific content */}
                {ctrl.platform && (
                    <main className='ts-wizard-content'>
                        <Translate text='WIZARD.ENTRY.SMS_HANDLING' />
                        <ol className='steps-list'>
                            <li>
                                {ctrl.isVisible('android') && (
                                    <span className='orange-text'>
                                        <Translate text='WIZARD.ENTRY.ASK_SMS_ANDROID' />
                                    </span>
                                )}
                                {ctrl.isVisible('apple') && (
                                    <span className='orange-text'>
                                        <Translate text='WIZARD.ENTRY.ASK_SMS_IPHONE' />
                                    </span>
                                )}

                                {/* Android images */}
                                {ctrl.isVisible('android') && (
                                    <div className='wizard-images-container'>
                                        <TsModalImage
                                            imageSrc='wizard/android/sms-notification.png'
                                            imageTitle='WIZARD.ENTRY.ANDROID_STEP_1'
                                            imageText='WIZARD.ENTRY.OPEN_LINK'
                                            imageNote='WIZARD.SCREENS_MAY_VARY'
                                        />
                                        <TsModalImage
                                            imageSrc='wizard/android/sms-tap.png'
                                            imageTitle='WIZARD.ENTRY.ANDROID_STEP_2'
                                            imageText='WIZARD.ENTRY.TAP_OPEN_LINK'
                                            imageNote='WIZARD.SCREENS_MAY_VARY'
                                        />
                                        <TsModalImage
                                            imageSrc='wizard/android/sms-approve.png'
                                            imageTitle='WIZARD.ENTRY.ANDROID_STEP_3'
                                            imageText='WIZARD.ENTRY.APPROVE_POPUP'
                                            imageNote='WIZARD.SCREENS_MAY_VARY'
                                        />
                                    </div>
                                )}

                                {/* iPhone images */}
                                {ctrl.isVisible('apple') && (
                                    <div className='wizard-images-container'>
                                        <TsModalImage
                                            imageSrc='wizard/iphone/sms-notification.png'
                                            imageTitle='WIZARD.ENTRY.IPHONE_STEP_1'
                                            imageText='WIZARD.ENTRY.OPEN_LINK'
                                            imageNote=''
                                        />
                                        <TsModalImage
                                            imageSrc='wizard/iphone/sms-tap.png'
                                            imageTitle='WIZARD.ENTRY.IPHONE_STEP_2'
                                            imageText='WIZARD.ENTRY.OPEN_LINK'
                                            imageNote=''
                                        />
                                    </div>
                                )}

                                {ctrl.isVisible('android') && (
                                    <div className='row'>
                                        <div className='col-sm-9 text-center ts-warning-note'>
                                            <Translate text='WIZARD.SCREENS_MAY_VARY' />
                                        </div>
                                    </div>
                                )}

                                <button type='submit' className='btn btn-wizard btn-wizard-back' onClick={ctrl.back}>
                                    <Translate text='WIZARD.BACK' />
                                </button>
                            </li>
                        </ol>

                        {/* Troubleshooting section */}
                        <h4 className='tbs-header'>
                            <Translate text='WIZARD.TROUBLESHOOTING' />
                        </h4>
                        {/* Add accordion component here if needed */}
                    </main>
                )}
            </div>
        );
    }
}
